export enum LicenseTypeEnum {
  SLM = "SLM",
  NLM = "NLM",
  NAMED_USER = "NAMED_USER",
  ONE_TIME = "ONE_TIME"
}

export enum CurrencyEnum {
  NOK = "NOK",
  SEK = "SEK",
  EUR = "EUR",
  DKK = "DKK",
  USD = "USD"
}

export enum OrderStateEnum {
  Unknown = "Unknown",
  Open = "Open",
  SentToVisma = "SentToVisma",
  SentToGlobal = "SentToGlobal",
  LicenseTerminated = "LicenseTerminated",
  ContractTerminated = "ContractTerminated",
  Handled = "Handled",
  Deleted = "Deleted",
  Failed = "Failed",
  Pending = "Pending"
}

export enum VismaClientEnum {
  FOCUS = "Focus",
  SLETTEN = "Sletten",
  BYGGDATA = "ByggData"
}
export enum ContractTypeEnum {
  FOCUS = "Focus",
  SUPPORT = "Support",
  SLETTEN = "Sletten",
  BYGGDATA = "ByggData"
}

export enum ContractStatusEnum {
  DRAFT = "Draft",
  IN_APPROVAL = "InApproval",
  ACTIVE = "Active",
  EXPIRED = "Expired",
  CANCELED = "Canceled",
  COMPLETED = "Completed",
  IN_UPGRADE = "InUpgrade",
  PENDING_ACTIVATION = "PendingActivation",
  COMBINED = "Combined"
}

export enum ContractOrderTypesEnum {
  AddSeats = "AddSeats",
  AddProductsToContract = "AddProductsToContract",
  RemoveContract = "RemoveContract",
  TerminateLicense = "TerminateLicense",
  ChangeRecurringDiscountPercent = "ChangeRecurringDiscountPercent",
  MoveInvoice = "MoveInvoice",
  ChangeInfo = "ChangeInfo",
  LicenseExpiration = "LicenseExpiration"
}

export enum OrderTypesEnum {
  //Lage kontrakt
  CreateContract = "NewContractOrder",//ikke i bruk på min side
  //Lage support kontrakt
  CreateSupportContract = "NewSupportContractOrder",//ikke i bruk på min side
  //Inneholder
  //1. nye seter ordre
  //2. Nye lisenser/items ordre
  //3. avslutte lisens
  //4. avslutte lisens, beholde vedlikehold 
  CompositeSale = "CompositeSaleOrder",//ikke i bruk på min side
  //Inneholder
  //1. nye seter ordre
  //2. Nye lisenser/items ordre
  //3. avslutte lisens
  //4. avslutte lisens, beholde vedlikehold 
  SupportCompositeSale = "SupportCompositeSaleOrder",//ikke i bruk på min side
  // Flytte en kontrakt fra ett firma til ett annet. Trenger IKKE være samme gruppe
  MoveContracts = "MoveContractOrder", //ikke i bruk på min side
  //Endre info på kontakt (kontraktansvarlig, fakturaansvarlig osv)
  ChangeContractInfo = "ChangeContractInfoOrder",//ikke i bruk på min side
  //Slå sammen to eller flere kontrakter (flytte lisenser fra en kontrakt til en annen og fakturere mellomlegget) 
  CombineContracts = "CombineContractOrder",//ikke i bruk på min side
  //Endre brukertilgang og/eller koordinatorer på lisens 
  ChangeLicenseAccess = "LicenseAccessOrder",
  //Slette en konto
  DeleteAccount = "DeleteUserOrder",
  //Brukerens konto har blitt slettet
  IsDeleted = "IsDeleted",
  //Endre brukerkonto info (tlf, interesser osv)
  ChangeAccountInfo = "ChangeAccountOrder",
  // //Endre fornyelsestidspunkt på en kontrakt. Kan bare endres frem i tid, og betale mellomlegg
  // ChangeInvoiceDate = "ChangeInvoiceDateOrder",//ikke i bruk på min side
  //Opprett ny bruker i ett eksisterende firma
  NewUser = "NewUserOrder",
  //Opprett nytt firma og admin i firmaet
  NewCompany = "NewCompanyOrder",
  //Endre domenegodkjenning på lisenser
  ChangeDomain = "DomainOrder",
  //Endre personer på brukerstøttekontrakt
  ChangeSupportUsers = "ChangeSupportUsersOrder",
  //Be om tilgang på en lisens
  RequestLicenseAccess = "RequestLicenseAccessOrder",
  //Avslår en lisenstilgang, ny bruker eller nytt firma
  RejectAccess = "RejectAccessOrder",
  //brukere er blitt invitert til å bli med i firmaet
  InviteUsers = "InviteUsersToCompanyOrder",
  //Endre på firmainformasjon (Kun to-faktor i versjon 1)
  ChangeCompanyInfo = "ChangeCompanyInfoOrder",
  //Ny brukerstøttemelding
  NewSupportMessage = "NewSupportMessageOrder",
  //Ny brukerstøttesak
  SupportTicketAdded = "SupportTicketAdded",
  //Vedlegg lastet opp til SO
  AttachmentAddedToSuperOffice = "AttachmentAddedToSuperOffice",
  //Vedlegg lastet opp i support sak
  AttachmentAddedToMessage = "AttachmentAddedToMessage",
  //Bruker opprettet i Azure AD, ikke i bruk på minside
  CreateUnregisteredUser = "CreateUnregisteredUserOrder",
  //Godkjenning av uregistrert brukerforespørsel
  ActivateUnregisteredUser = "ActivateUnregisteredUserOrder",
  //ikke i bruk på minside
  ActivateUnregisteredCompany = "ActivateUnregisteredCompanyOrder",
  //Webkua event, muligens ikke i bruk på minside
  AdminEditAccount = "AdminEditAccountOrder",
  //Webkua event, muligens ikke i bruk på minside
  AdminEditPerson = "AdminEditPersonOrder",
  //Webkua event, muligens kke i bruk på minside
  ReopenUserAccount = "ReopenUserAccountOrder",
  //Endring av fornyelsestidspunkt for kontrakt
  InvoiceDateOrder = "InvoiceDateOrder",
  //Endgring av firmagruppe
  ChangeCompanyGroupOrder = "ChangeCompanyGroupOrder",
  //Flytt av brukerkontoer mellom firmaer
  MoveAccountsToCompanyOrder = "MoveAccountsToCompanyOrder",
  //Admin endring av lisens
  AdminEditLicenseOrder = "AdminEditLicenseOrder",
  //Resend invitation to company
  ResendInviteOrder = "ResendInviteOrder",
  //Finish unregistered account
  FinishUnregisteredUserOrder = "FinishUnregisteredUserOrder",
  InitializeCourseOrder = "InitializeCourseOrder",
  NewCompanyWithoutAdminOrder = "NewCompanyWithoutAdminOrder",
  LicenseAccessChangeOrder = "LicenseAccessChangeOrder",
  NewUserRequestOrder = "NewUserRequestOrder",
  NewCompanyRequestOrder = "NewCompanyRequestOrder",
  AcceptCompanyRequestOrder = "AcceptCompanyRequestOrder",
  SendSaleProposalOrder = "SendSaleProposalOrder",
  RejectProposalOrder = "RejectProposalOrder",
  SendCounterProposalOrder = "SendCounterProposalOrder",
  CompanyContactOrder = "CompanyContactOrder",
  SFCreateCompanyOrder = "SFCreateCompanyOrder",
  SFUpdateCompanyOrder = "SFUpdateCompanyOrder",
  SFChangeAssetOrder = "SFChangeAssetOrder",
  SFAddSupportHoursOrder = "SFAddSupportHoursOrder",
  SFUpdateContractOrder = "SFUpdateContractOrder",
}

export enum ExceptionTypesEnum {
  //LicenseAccessChangeOrder
  UncaughtException = "En ukjent feil har oppstått.",
  CannotChangeOfflineLicense = "Lisensen er offline og kan ikke endre tilgang.",
  NoLicenseFound = "Fant ingen lisens med dette nummeret. Vennligst sjekk og prøv igjen.",
  UserNotFoundByEmail = "Fant ingen bruker med denne e-postadressen. Vennligst sjekk og prøv igjen.",
  UserIsNotActive = "Brukeren er ikke aktiv. Kun aktive brukere kan endre tilgang.",
  InsufficientSeatsNamedUser = "Lisensen for navngitt bruker har ikke nok tilgjengelige seter til å legge til flere brukere.",
  UnauthorizedLicenseChange = "Denne brukeren har ikke rettigheter til å endre brukere på denne lisensen.",
  UnauthorizedCoordinatorChange = "Denne brukeren har ikke rettigheter til å endre koordinatorer på denne lisensen.",

  //ActivateUnregisteredUserOrder
  DuplicateEmailFound = "Det finnes flere personer registrert med e-postadressen i systemet. Vennligst kontakt support for hjelp.",
  EmailNotFound = "Ingen person er registrert med e-postadressen i systemet. Vennligst sjekk at adressen er korrekt.",
  OrderIdMissing = "Ordre-ID er ikke angitt. Vennligst oppgi en gyldig Ordre-ID.",
  OrderNotFound = "Ingen ordre funnet med den ID'en. Vennligst sjekk at ID-en er korrekt.",
  UserNotAssociated = "Ingen bruker er tilknyttet denne ordren. Vennligst logg inn og prøv igjen.",
  InsufficientRightsForApproval = "Brukeren har ikke nødvendige rettigheter til å godkjenne brukere. Du må være co-admin eller admin for å utføre denne handlingen.",

  //ChangeAccountOrder
  InterestIdListMissing = "Ingen liste med interest-IDer er angitt. Vennligst oppgi en gyldig liste.",
  TwoFactorStatusMissing = "To-faktor-autentisering er ikke angitt. Vennligst aktiver eller deaktiver dette alternativet.",
  AccountNotFound = "Ingen konto er angitt. Vennligst sjekk at en gyldig konto er knyttet til brukeren.",
  NotificationsNotConfigured = "Notifikasjonsinnstillinger er ikke angitt. Vennligst konfigurer notifikasjonsinnstillingene.",
  UnauthorizedAccountChange = "Du kan kun gjøre endringer på din egen konto.",

  //ChangeCompanyInfoOrder
  CoAdminListMissing = "Listen over co-administratorer er ikke angitt. Vennligst oppgi en gyldig liste.",
  InsufficientPermissionsForCompanyUpdate = "Du må ha admin- eller co-admin-rettigheter for å endre firmainformasjon. Vennligst kontakt en administrator for hjelp.",

  //ContractSaleOrder
  CompanyNotFoundForContract = "Fant ikke firma for dette kontraktnummeret. Vennligst sjekk kontraktnummeret.",
  ContractNumberMissing = "Kontraktnummer mangler. Vennligst fyll ut kontraktnummer.",
  NoProductSelectedForSale = "Du må velge minst ett produkt for salget.",
  ProductInfoNotFound = "Fant ikke produktinformasjon for produktet. Vennligst sjekk produktdetaljer.", 
  InvalidProductQuantity = "Ugyldig antall for produktet. Vennligst oppdater antallet.", 
  ProductNotForSale = "Produktet er ikke til salgs. Vennligst velg et annet produkt.", 
  AccountNotFoundForOrder = "Fant ikke konto for orderen. Vennligst sjekk kontoen knyttet til orderen.",
  InactiveAccount = "Brukeren har ikke en aktiv konto i dette firmaet. Vennligst aktiver kontoen.", 
  UnauthorizedToAcceptOffer = "Brukeren er ikke autorisert til å fullføre salget. Du må ha administratorrettigheter, være salgsrepresentant, eller mottaker av tilbudet.",

  //CreateUnregisteredUserOrder
  AccountAlreadyExists = "Det finnes allerede en konto med denne e-posten i dette firmaet. Vennligst bruk en annen e-postadresse eller kontroller eksisterende konto.",

  //DeleteUserOrder
  EmailMissing = "Ingen e-postadresse er angitt. Vennligst oppgi en gyldig e-postadresse.",
  AdminCannotBeDeleted = "Administratorer kan ikke slettes. Du må ha administratorrettigheter for å utføre denne handlingen.",
  UnauthorizedCompanyDeletion = "Partnere kan kun slette kontoer i firmaer de er ansvarlige for.",
  InsufficientRightsToDeleteUser = "Du må ha administratorrettigheter for å kunne slette andre brukere.",

  //DomainOrder
  LicenseNumbersMissing = "Listen over lisensnumre er ikke angitt. Vennligst oppgi en gyldig liste.",
  DomainsMissing = "Domenelisten er ikke angitt. Vennligst oppgi en gyldig liste.",
  CompanyNumbersMissing = "Firmalisten er ikke angitt. Vennligst oppgi en gyldig liste.",
  NamedUserLicenseNotAllowed = "Lisensen er en navngitt bruker, som ikke er tillatt.",
  UnauthorizedLicenseAssignment = "Brukeren har ikke nødvendige rettigheter til å endre denne lisensen. Du må ha administratorrettigheter for å utføre denne handlingen.",

  //InviteUsersToCompanyOrder
  DuplicateEmailAddresses = "Det finnes allerede noen registrerte kontoer med disse e-postadressene. Vennligst bruk unike e-postadresser.",
  InvalidEmailFormat = "E-posten er ikke gyldig. Vennligst sjekk formatet og prøv igjen.",
  InvalidEmailCharacters = "E-posten mangler nødvendige tegn. Vennligst oppgi en gyldig e-postadresse.",
  UserIdMissing = "Brukeren med denne e-posten mangler en ID. Vennligst kontroller brukerens opplysninger.",
  UnauthorizedUserInvite = "Brukeren har ikke nødvendige rettigheter for å invitere nye brukere. Du må ha administratorrettigheter for å utføre denne handlingen.",

  //LicenseAccessOrder
  OfflineLicenseError = "Lisens er offline og kan ikke endre tilgang. Vennligst sjekk lisensens status.",
  NimbusUserIdMissing = "Bruker mangler Nimbus-ID. Vennligst oppdater brukerens informasjon.",
  InsufficientSeatsForNamedUserLicense = "Navngitt bruker lisens har ikke nok seter tilgjengelig for å legge til flere brukere. Vennligst sjekk antall seter på lisensen.",
  CoordinatorNimbusIdMissing = "Koordinatoren mangler Nimbus-ID. Vennligst sørg for at alle koordinatorer har en gyldig Nimbus-ID.",

  //NewCompanyOrder
  MissingOrgNumber = "Organisasjonsnummer er ikke angitt. Vennligst oppgi et gyldig organisasjonsnummer.",
  MissingCompanyName = "Firmanavn er ikke angitt. Vennligst oppgi et gyldig firmanavn.",
  MissingAdmin = "Administrator er ikke angitt. Vennligst legg til en administrator for firmaet.",
  MissingAdminEmail = "Administratorens e-post mangler. Vennligst oppgi en gyldig e-postadresse.",
  MissingAdminFirstName = "Administratorens fornavn mangler. Vennligst oppgi et fornavn.",
  MissingAdminLastName = "Administratorens etternavn mangler. Vennligst oppgi et etternavn.",
  MissingSeller = "Ingen selger er tilknyttet firmaet. Vennligst legg til en selger.",
  InvalidCompanyNumber = "Firmanummeret er ugyldig. Firmanummeret må bestå av et gyldig antall sifre.",
  CompanyNumberAlreadyExists = "Kan ikke opprette nytt firma med dette firmanummer, da det allerede eksisterer.",

  //NewCompanyRequestOrder
  MissingAdminForOrder = "Ingen administrator er angitt for ordren. Vennligst oppgi en administrator.",
  MissingCompanyNameForOrder = "Orderen mangler firmanavn. Vennligst oppgi et gyldig firmanavn.",
  MissingOrgNumberForOrder = "Ordren mangler organisasjonsnummer. Vennligst oppgi et gyldig organisasjonsnummer.",
  AdminAccountNotFound = "Administratorkonto ble ikke funnet. Vennligst sjekk og prøv igjen.",
  AdminAccountHasCompany = "Administratorkontoen er allerede tilknyttet et firma. Vennligst bruk en konto uten firmatilknytning.",
  OrderAlreadyExistsForOrgNumber = "Det finnes allerede en ordre for dette organisasjonsnummeret. Vennligst kontroller opplysningene og prøv igjen.",

  //NewContractSaleOrder
  CompanyNotFound = "Et firma med dette firmanummeret ble ikke funnet. Vennligst dobbeltsjekk nummeret og prøv igjen.",
  MissingContractNumber = "Kontraktnummer mangler for den nye kontrakten. Vennligst oppgi kontraktnummer.",
  NoProductSelected = "Minst ett produkt må velges for salget. Vennligst velg et produkt.",
  MissingProductInfo = "Fant ikke produktinformasjon for produktet. Vennligst kontroller produktdata.",
  InvalidQuantity = "Antall for produktet kan ikke være mindre enn 1. Vennligst juster antallet.",
  AccountInactive = "Kontoen til denne brukeren er inaktiv. Vennligst aktiver kontoen for å fortsette.",
  UnauthorizedSale = "Brukeren har ikke rettigheter til å fullføre dette salget. Brukeren må være admin, salgsrepresentant, eller mottaker av tilbudet.",

  //NewSupportMessageOrder
  MissingMessage = "Meldingen er ikke angitt. Vennligst skriv en melding før du fortsetter.",
  UserNotLoggedIn = "Brukeren er ikke logget inn. Vennligst logg inn før du prøver igjen.",

  //NewUserOrder
  EmailAlreadyRegistered = "En bruker med e-postadressen er allerede registrert. Vennligst prøv med en annen e-postadresse.",
  MissingCompanyNumber = "Firmanummer er ikke angitt. Vennlist oppgi et gyldig firmanummer.",

  //NewUserRequestOrder
  MissingFirstName = "Fornavn ikke angitt. Vennligst oppgi fornavn.",
  MissingLastName = "Etternavn ikke angitt. Vennligst oppgi etternavn.",
  MissingPhoneNumber = "Telefonnummer ikke angitt. Vennligst oppgi et telefonnummer.",
  MissingAdminAccounts = "Ingen brukere med adminrettigheter funnet for firmaet.",
  MissingEmail = "E-postadressen er ikke angitt. Vennligst oppgi en gyldig e-postadresse.", 

  //RemindAdminOfAccountRequestOrder
  AdminNotFound = "Kunne ikke finne en administrator med den e-postadressen. Vennligst kontroller adressen og prøv på nytt.",
  UserAlreadyRegistered = "Brukeren er allerede registrert i dette firmaet. Hvis dette er en feil, vennligst ta kontakt med support.",
  UserAlreadyActivated = "Bruker er allerede aktivert. Det er ikke nødvendig å aktivere på nytt.",
  UserNotBlocked = "Bruker er ikke blokkert.",

  //CompanyContactOrder
  MissingCompany = "Firmaet er ikke angitt. Vennligst oppgi et gyldig firma.",
  MissingAccount = "Kontoen er ikke angitt. Vennligst oppgi en gyldig konto.",
}

export interface IWebkuaSignalRResponse {
  OrderType: OrderTypesEnum,
  UserId: string,
  ErrorText: string,
  StepName: string
}

export interface IWebkuaSignalRStatusResponse extends IWebkuaSignalRResponse {
  StepNumber: number
}

export interface IInvoiceInfo {
  invoicedCompanyNumber: string,
  vismaClient: VismaClientEnum,
  invoiceResponsibleName?: string,
  reference: string,
  note: string
}

export interface IContractInfo {
  terminationDate?: Date,
  nextInvoicingDate: Date,
  activationDate: Date,
  invoiceInterval: number,
  sellerEmail?: string,
  contractResponsibleEmail: string,
  note: string,
  currency: CurrencyEnum,
  status: ContractStatusEnum,
}

export interface IContractGroup {
  groupName: string,
  id: string,
  iconUrl: string,
  licenses: Array<IContractLicense>,
  terminatedLicenses: Array<IContractLicense>
}

export interface IContractLicense {
  items: Array<IContractItem>,
  licenseNumber: number,
  productName: string,
  parentLicenseNumber?: number,
  terminationDate?: Date,
  maintenanceExpirationDate?: Date,
  nextInvoiceCost: number,
  unitCost: number,
  itemType: LicenseTypeEnum,
  numberOfSeats: number,
  modules: Array<IContractLicense>
}

export interface ISalesforceNavigation {
  status: 'Linked' | 'NotLinked' | 'Ambiguous' | 'Unavailable';
  recordId?: string | null;
}

export interface ICustomerContract {
  contractNumber: string,
  companyName?: string,
  companyNumber?: string,
  groups: Array<IContractGroup>
  contractInfo: IContractInfo,
  invoiceInfo: IInvoiceInfo,
  nextInvoiceCost: number,
  sellerName: string,
  orderItems: Array<IOrderItem>,
  isLoaded: boolean,
  isAcademic?: boolean,
  contractType: ContractTypeEnum,
  isSupport?: boolean
}

export interface IContractStateType extends ICustomerContract {
  changeContractInfoOrder?: IChangeContractInfoOrder,
  moveInvoiceOrder?: any,
  accessChangeOrder?: any,
  sellableProducts?: ISellableProducts[],
  contractEmployeeList?: IUserAccount[],
  invoiceEmployeeList?: IUserAccount[],
  existingOrders?: IExistingOrderType[],
  newSaleDate?: Date,
  isNew?: boolean,
  saleMessage?: string,
  reasonForSale?: { value: number, name: string },
}

export interface IContractItem {
  quantity: number,
  id: string,
  recurringPrice: number,
  setupBasePrice?: number,
  parentLicenseNumber?: number,
  productName: string,
  recurringDiscountPercent?: number,
  vismaContractItemId: string,
  licenseNumber: number
}

export interface IBaseOrderItem extends IContractItem {
  licenseId: string,
  contractItemId: string
}

export interface IOrderItem extends IBaseOrderItem {
  itemType: LicenseTypeEnum
  parentLicenseId?: string,
  oneTimeDiscountAmount?: number,
  type: ContractOrderTypesEnum,
  isModule?: boolean,
  activationDate: Date,
  groupId?: string,
  isExisting?: boolean,
  isConnectedItem?: boolean
}

export interface IEditableContractLicense extends IContractLicense {
  items: Array<IEditableContractItem>
}

export interface IEditableContractItem extends IContractItem {
  isNew?: boolean,
  oneTimeDiscount?: number
}

export interface IContractOrder {
  invoiceInfo: IInvoiceInfo,
  contractInfo: IContractInfo,
}

export interface ISeatChangeOrder {
  items: Array<IOrderItem>
}

export interface INewLicensesOrder {
  items: Array<INewLicenseOrderItem>
}

export interface ILicenseTerminationOrder {
  items: Array<IOrderItem>,
  activationDate: Date
}

export interface IDiscountChangeOrder {
  items: Array<IOrderItem>
}

export interface IChangeContractInfoOrder {
  contractNumber: string,
  companyNumber?: string,
  orderType: ContractOrderTypesEnum,
  contractInfo: IContractInfo,
  invoiceInfo: IInvoiceInfo,
  invoiceChanges: Array<string>,
  contractInfoChanges: Array<string>,
  state: OrderStateEnum,
  id: string
}

export interface ILicenseAccessChange {
  licenseNumber: number,
  giveAccess: boolean,
  email: string,
  isCoordinator: boolean
}

export interface ILicenseAccessChangeOrder {
  accessChanges: ILicenseAccessChange[],
  changedByCustomer: boolean
}

export interface INewLicenseOrderItem extends IOrderItem {
  groupId: string,
  itemType: LicenseTypeEnum
}

export interface IExistingOrderType {
  activationDate: string,
  comment?: string,
  items: Array<IExistingOrderItemType>,
  orderDate: string,
  price: number,
  state: OrderStateEnum,
}

export interface IExistingOrderItemType {
  salePrice: number,
  id: string,
  discount: number,
  quantity: number,
  productName: string,
  changeDescription: string,
  licenseNumber: number,
  vismaContractItemId: string
}


export interface ISellableProducts {
  groupName: string,
  groupId: string,
  namedUsers: Array<ISellableProduct>,
  nlm: Array<ISellableProduct>,
  slm: Array<ISellableProduct>,
  oneTime: Array<ISellableProduct>,

}

interface IConnectedItem {
  idOfConnected: string,
  newLicense: boolean,
  requiredQuantity: number
}

export interface ISellableProduct {
  productName: string,
  price: number,
  vismaId: string,
  groupId: string,
  licenseType: LicenseTypeEnum,
  isModule: boolean,
  connectedItem?: IConnectedItem,
  isConnectedItem?: boolean
}

interface IBasicContactType {
  department: string,
  number: string,
  name: string,
  id: number,
  group: Array<{
    companyNumber: string,
    contactId: number,
    isParent: boolean,
    name: string,
    stop: boolean
  }> | null
}

export interface IContactType extends IBasicContactType {
  licenseNumbers?: number,
  isExported: boolean,
  orgNr: string,
  isBlocked: boolean
}

export interface IAccount {
  id: number,
  name: string,
  isStudent: boolean,
  isBlocked: boolean
}

export interface IPerson {
  email: string,
  firstName: string,
  lastName: string,
  title: string,
  focusAccounts: Array<IAccount>,
  isNimbusUser: boolean,
  isSupportUser: boolean,
  isLicenseCoordinator: boolean,
  isRetired: boolean,
  activeLicenses: number,
  mobile: string,
  personId: number,
  supportContractNumbers: Array<number>,
  companyNumber: string
}

export interface IUserAccount {
  firstName: string,
  lastName: string,
  email: string,
  id: string,
  phoneNumber: string,
  isAcademic: boolean,
  isBlocked: boolean,
  isRetired: boolean,
  companyNumber: string,
  companyName: string,
  superOfficeId: number,
  nimbusUserId: number,
  accessToLicenses: number[],
  coordinatorForLicenses: number[],
  responsibleForContracts: string[],
  role: number,
  interestIds: number[],
  isSuperUser: boolean,
  isActivated: boolean,
  twoFactorEnabled: boolean
}

export interface IProductGroup {
  currentSeats: number,
  licenseNumber: number,
  name: string,
  recurringPrice: number,
  priceToRenewal: number,
  productId: string,
  itemInfoId: string,
  oneTimeDiscountAmount: number,
  recurringDiscountPercent: number,
  licenseType: string,
  allowCustomerSeatAlteration: boolean,
  newSeats: number, //frontend only
  isLastProductInGroup: boolean, // frontend only
  itemType: number,  // frontend only
  itemTypeName: string  // frontend only
}